module.exports = "<h1 class=\"md-display-1 md-warn\">{{'ui.notfound.message' | translate}}</h1>\r\n<md-button class=\"md-raised md-warn\" ng-click=\"$ctrl.goToLastValidState()\">\r\n    <md-icon md-svg-icon=\"images/svg/back.svg\"></md-icon>{{'ui.button.back' | translate}}\r\n</md-button>\r\n";


//////////////////
// WEBPACK FOOTER
// ./src/main/front/scripts/module/util/component/not-found.html
// module id = 306
// module chunks = 1